import styled, { keyframes } from "styled-components";
import { TextTheme, ButtonTheme, ColorTheme, ShadowTheme, BorderRadiusTheme, SpacingTheme } from "../globaStyledComponents/globalStyledComponentsStyling";
// Styling for search Auth

interface authBarProps {
    pageName?: string;
    invalid?: boolean;
    resendReady?: boolean;
    mfaInvalid?: boolean;
    isGoogleAccountExist?: boolean;
    type?: string;
}

export const AuthContainer = styled.div`
    width: 100%;
`;

export const AuthSignInWrapper = styled.div<authBarProps>`
    position: fixed;
    z-index: 102;
    left: 0;
    bottom: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(48px) saturate(180%);
    -webkit-backdrop-filter: blur(48px) saturate(180%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: ${ShadowTheme.shadow_300.boxShadow};
    overflow: hidden;
    padding: ${SpacingTheme.spacing_400.padding} ${SpacingTheme.spacing_400.padding} ${SpacingTheme.spacing_300.padding} ${SpacingTheme.spacing_400.padding};
    border: 1px solid rgba(255, 255, 255, 0.18);

    & > div:first-child {
        width: 100%;
        height: 100%;
    }
`;

export const AuthSignUpWrapper = styled.div`
    position: fixed;
    padding: ${SpacingTheme.spacing_400.padding} ${SpacingTheme.spacing_400.padding} ${SpacingTheme.spacing_300.padding} ${SpacingTheme.spacing_400.padding};
    z-index: 102;
    left: 0;
    bottom: 0;
    width: 100%;
    max-height: calc(100vh - 120px);
    background: ${ColorTheme.White.color};
    border-radius: 12px 12px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: ${ShadowTheme.shadow_300.boxShadow};
    overflow: scroll;
    height: fit-content;

    ::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: 768px) {
        width: 560px;
        border-radius: 12px;
        padding: ${SpacingTheme.spacing_400.padding};
        margin: auto;
        left: 0;
        right: 0;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }
`;

export const AuthTitle = styled.p`
    position: absolute;
    font-size: ${TextTheme.sans_400_semi.fontSize};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    line-height: ${TextTheme.sans_300_semi.lineHeight};
    justify-self: center;
    margin: 0;
`;

export const AuthTitleCrossIconButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    top: 12px;
    left: 12px;
    width: 40px;
    height: 40px;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};

    &:hover {
        background-color: ${ColorTheme.Grey5.color};
    }
`;

export const AuthTitleArrowIconButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    top: 12px;
    left: 12px;
    width: 40px;
    height: 40px;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
`;

export const AuthTitleIcon = styled.img`
    width: 16px;
    height: 16px;
    object-fit: cover;
    margin: ${SpacingTheme.spacing_250.margin};
`;

export const AuthContentWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0;
    overflow-y: auto;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: 768px) {
        max-width: 380px;
        margin: 0 auto;
    }
`;
export const AuthContentTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0 auto 24px;
`;

export const AuthContentTitleIcon = styled.img`
    width: 34px;
    height: 34px;
    margin: 0;

    @media (min-width: 768px) {
        width: 45px;
        height: 45px;
    }
`;

export const AuthContentTitle = styled.p`
    font-size: ${TextTheme.sans_800_semi.fontSize};
    line-height: ${TextTheme.sans_800_semi.lineHeight};
    font-family: ${TextTheme.sans_800_semi.fontFamily};
`;
export const AuthContentSubTitle = styled.p`
    font-size: ${TextTheme.sans_400.fontSize};
    line-height: ${TextTheme.sans_400.lineHeight};
    font-family: ${TextTheme.sans_400.fontFamily};
    color: ${ColorTheme.Red1.color};
    margin-top: 16px;
`;

export const AuthSignInSubPage = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const AuthSignInInput = styled.input<authBarProps>`
    height: 54px;
    width: calc(100% - 16px);
    margin: ${SpacingTheme.spacing_400.margin} 0;
    padding: 0 16px;
    border: 1px solid ${(props) => (props.invalid ? ColorTheme.Red1.color : ColorTheme.Grey1.color)};
    border-radius: 12px;
    outline: none;
    font-size: ${TextTheme.sans_400.fontSize};
    background-color: transparent;

    &:focus {
    }

    @media (min-width: 768px) {
        margin-bottom: 32px;
    }
`;

export const AuthTermsAndConditionsText = styled.p`
    font-size: ${TextTheme.sans_200.fontSize};
    font-family: ${TextTheme.sans_200.fontFamily};
    line-height: ${TextTheme.sans_200.lineHeight};
    margin: ${SpacingTheme.spacing_250.margin} 0 ${SpacingTheme.spacing_300.margin};

    a {
        font-family: ${TextTheme.sans_200_semi.fontFamily};
        text-decoration: underline;
        border: none;
        background: none;
    }

    @media (min-width: 768px) {
        width: 400px;
        height: 32px;
    }
`;

export const AuthSignUpInput = styled.input<authBarProps>`
    height: 54px;
    width: 100%;
    margin: ${SpacingTheme.spacing_250.margin} 0 ${SpacingTheme.spacing_400.margin};
    padding: 0;
    padding-left: 16px;
    border: ${(props) => (props.invalid ? `1px solid ${ColorTheme.Red1.color}` : `1px solid ${ColorTheme.Grey1.color}`)};
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    outline: none;
    font-size: ${TextTheme.sans_400.fontSize};
    line-height: ${TextTheme.sans_400.lineHeight};
    font-family: ${TextTheme.sans_400.fontFamily};

    &:focus {
    }

    @media (min-width: 768px) {
        height: 54px;
        margin-top: 12px;
    }
`;

export const AuthSignUpInputDOB = styled.input<authBarProps>`
    height: 54px;
    width: 100%;
    margin: ${SpacingTheme.spacing_250.margin} 0 ${SpacingTheme.spacing_400.margin};
    padding: 0;
    padding-left: 16px;
    border: ${(props) => (props.invalid ? `1px solid ${ColorTheme.Red1.color}` : `1px solid ${ColorTheme.Grey1.color}`)};
    border-radius: ${BorderRadiusTheme.radius_12.borderRadius};
    outline: none;
    font-size: ${TextTheme.sans_400.fontSize};
    line-height: ${TextTheme.sans_400.lineHeight};
    font-family: ${TextTheme.sans_400.fontFamily};

    &:focus {
        /* box-shadow: 0 0 3px ${ColorTheme.Red.color}; */
    }

    @media (min-width: 768px) {
        height: 54px;
        margin-top: 12px;
    }
`;

export const AuthSignInLabel = styled.label<authBarProps>`
    margin: 0;
    font-size: ${TextTheme.sans_400_semi.fontSize};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    width: 100%;
    font-family: ${TextTheme.sans_300_semi.fontFamily};
    align-self: flex-start;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
        font-size: ${TextTheme.sans_300.fontSize};
        line-height: ${TextTheme.sans_300.lineHeight};
        font-family: ${TextTheme.sans_300.fontFamily};
        color: ${ColorTheme.Red1.color};
        display: ${(props) => (props.invalid ? "block" : "none")};
    }
`;

export const AuthSignInTitle = styled.label`
    font-size: ${TextTheme.sans_900_semi.fontSize};
    line-height: ${TextTheme.sans_900_semi.lineHeight};
    width: 100%;
    font-family: ${TextTheme.sans_900_semi.fontFamily};
    display: flex;
    justify-content: center;
    margin: 0;
    margin-bottom: ${SpacingTheme.spacing_500.margin};
`;

export const NewPasswordSubtitle = styled.p`
    font-size: ${TextTheme.sans_300.fontSize};
    font-style: normal;
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};
    text-align: center;
    margin-top: 0;
    margin-bottom: 24px;
`;

export const NewPasswordTitle = styled.p`
    font-size: ${TextTheme.sans_800_semi.fontSize};
    font-style: normal;
    font-family: ${TextTheme.sans_800_semi.fontFamily};
    line-height: ${TextTheme.sans_800_semi.lineHeight};
    width: 272px;
    text-align: center;
    margin: 0 0 24px 0;
`;

export const AuthSignInButton = styled.button`
    height: 48px;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    width: 100%;
    background: ${ColorTheme.Red.color};
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    font-family: ${ButtonTheme.sans_button_100.fontFamily};
    color: ${ColorTheme.White.color};
    margin-top: auto;
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    cursor: pointer;

    @media (min-width: 768px) {
        font-size: ${ButtonTheme.sans_button_200.fontSize};
        line-height: ${ButtonTheme.sans_button_200.lineHeight};
    }
`;

export const ResendCodeBtn = styled.p<authBarProps>`
    margin: 0;
    font-size: ${TextTheme.sans_300.fontSize};
    margin-bottom: 20px;
    font-family: ${TextTheme.sans_300.fontFamily};
    text-decoration: ${(props) => (props.resendReady ? "underline" : "none")};
    cursor: pointer;
`;

export const AuthForgotPasswordButton = styled.button`
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    background: none;
    border: none;
    margin-bottom: 92px;
    padding: 0;
    text-decoration: underline;
    cursor: pointer;
    width: 100%;
    text-align: center;

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_400_semi.fontSize};
        line-height: ${TextTheme.sans_400_semi.lineHeight};
    }
`;

export const AuthSignInMotionWrapper = styled.div`
    width: 100%;
`;

export const AuthSignUpForm = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    align-items: center;

    .verification-code-input input {
        font-size: ${TextTheme.sans_400.fontSize} !important;
    }
`;

export const AuthCancelBtn = styled.div`
    text-decoration: underline;
    color: ${ColorTheme.Black.color};
    font-size: ${TextTheme.sans_400_semi.fontSize};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    cursor: pointer;
`;

export const AuthSignUpButton = styled.button`
    min-height: 48px;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    width: 100%;
    background: ${ColorTheme.Red.color};
    position: relative;
    display: flex;
    justify-content: center;
    justify-self: flex-end;
    align-items: center;
    border: none;
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    font-family: ${ButtonTheme.sans_button_100.fontFamily};
    color: ${ColorTheme.White.color};
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    margin-bottom: 48px;
    margin-top: auto;
    cursor: pointer;

    @media (min-width: 768px) {
        font-size: ${ButtonTheme.sans_button_200.fontSize};
        line-height: ${ButtonTheme.sans_button_200.lineHeight};
    }
`;

export const AuthSignUpPhotoButton = styled.button`
    background: none;
    position: relative;
    display: flex;
    text-decoration: underline;
    border: none;
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    cursor: pointer;
    margin: ${SpacingTheme.spacing_300.margin} auto 0;
`;

export const AuthSignUpInitialSubPage = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const AuthSignUpCreateAccountSubPage = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const AuthSignUpConfirmAccountSubPage = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const AuthSignUpNameInputWrapper = styled.div`
    width: calc(100% - 16px);
    display: grid;
    grid-template-columns: 50% 50%;
    gap: ${SpacingTheme.spacing_300.gap};
    align-self: flex-start;
`;

export const AuthSignUpDOBInputWrapper = styled.div`
    width: 100%;
    display: flex;
    align-self: flex-start;
    gap: ${SpacingTheme.spacing_250.gap};
`;

interface AuthSignUpConfirmPhoneSubPageProps {
    pageName?: string;
}
export const AuthSignUpConfirmPhoneSubPage = styled.div<AuthSignUpConfirmPhoneSubPageProps>`
    width: 100%;
    height: calc(100% - 16px);
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const AuthSignUpConfirmPhoneTitle = styled.p`
    width: 100%;
    text-align: center;
    font-size: ${TextTheme.sans_400_semi.fontSize};
    font-family: ${TextTheme.sans_400_semi.fontFamily};
    line-height: ${TextTheme.sans_400_semi.lineHeight};
    margin-top: 48px;
    margin-bottom: 24px;
`;

export const AuthSignUpUploadYourPlaceLink = styled.button`
    height: 48px;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    border: 1px solid ${ColorTheme.Black.color};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    text-decoration: none;
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    cursor: pointer;
    font-family: ${ButtonTheme.sans_button_100.fontFamily};
    line-height: ${ButtonTheme.sans_button_100.lineHeight};

    @media (min-width: 768px) {
        font-size: ${ButtonTheme.sans_button_200.fontSize};
        line-height: ${ButtonTheme.sans_button_200.lineHeight};
    }
`;

export const AuthSignUpReadytoGoTitle = styled.p`
    width: 100%;
    text-align: center;
    font-size: ${TextTheme.sans_900_semi.fontSize};
    font-family: ${TextTheme.sans_900_semi.fontFamily};
    line-height: ${TextTheme.sans_900_semi.lineHeight};
    margin-top: 0px;
    margin-bottom: 12px;
    max-width: 320px;

    @media (min-width: 768px) {
        font-size: ${TextTheme.sans_1000_semi.fontSize};
        line-height: ${TextTheme.sans_1000_semi.lineHeight};
    }
`;

export const AuthSignUpConfirmPhoneSubtitle = styled.p`
    position: relative;
    max-width: 270px;
    width: 100%;
    text-align: center;
    font-size: ${TextTheme.sans_400.fontSize};
    font-family: ${TextTheme.sans_400.fontFamily};
    line-height: ${TextTheme.sans_400.lineHeight};
    margin: 0 auto;
    margin-bottom: 84px;
`;

export const AuthSignUpAmplifyImageWrapper = styled.div`
    width: 128px;
    height: 128px;
    margin-top: 96px;
    margin-bottom: 32px;
`;

export const AuthSignUpUploadPhotoWrapper = styled.div`
    width: 100%;
    margin-top: auto;
`;

export const AuthSignUpUploadPhotoButton = styled.button`
    width: 100%;
    background: none;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    color: ${ColorTheme.White.color};
    background: ${ColorTheme.Black.color};
    cursor: pointer;
    /* margin-top: 24px; */
`;

export const PhoneInputWrapper = styled.div`
    input {
        outline: none;
        border: none;
    }
    
    .PhoneInputCountrySelectArrow {
        display: none;
    }

    .PhoneInputCountryIcon--border {
        box-shadow: none;
    }
`;

export const ProfileAuthSignInImage = styled.img`
    width: 128px;
    height: 128px;
    object-fit: cover;
    border-radius: 50%;
`;

export const AuthMFASubtitle = styled.p`
    text-align: center;
    width: 100%;
    margin-bottom: 48px;
    font-size: ${TextTheme.sans_700_semi.fontSize};
    font-family: ${TextTheme.sans_700_semi.fontFamily};
    line-height: ${TextTheme.sans_700_semi.lineHeight};
    margin-top: 32px;

    span {
        cursor: pointer;
        color: ${ColorTheme.Black.color} !important;
    }
`;
export const AuthMFAInvalid = styled.p<authBarProps>`
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};
    margin-top: auto;
    margin-bottom: 16px;
    color: ${ColorTheme.Red1.color};
    opacity: ${(props) => (props.mfaInvalid ? 1 : 0)};
`;

export const AuthSignInInputSubtitle = styled.p<authBarProps>`
    margin-top: 12px;
    margin-bottom: 0px;
    font-size: ${TextTheme.sans_200.fontSize};
    text-align: left;
    font-family: ${TextTheme.sans_200.fontFamily};
    color: ${(props) => (props.invalid ? ColorTheme.Red1.color : ColorTheme.Black.color)};
    line-height: ${TextTheme.sans_200.lineHeight};
    max-width: 360px;
`;

export const AuthSignInSocialButton = styled.button`
    height: 80px;
    width: 100%;
    // background: ${ColorTheme.White.color};
    display: flex;
    align-items: center;
    border: 1px solid ${ColorTheme.Grey1.color};
    border-radius: ${BorderRadiusTheme.radius_16.borderRadius};
    cursor: pointer;
    margin: ${SpacingTheme.spacing_500.margin} auto 0;
    margin-bottom: 8px;
`;

// export const AuthSignInSocialIconWrapper = styled.div`
//     height: 24px;
//     width: 24px;
//     background: ${ColorTheme.Grey2.color};
//     border-radius: 5px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
// `;

export const AuthSignInSocialIcon = styled.img`
    height: 32px;
    width: 32px;
    object-fit: cover;
    margin-left: auto;
`;

export const AuthSignInSocialTitle = styled.p`
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    justify-self: center;
    text-align: center;
    margin-left: 12px;
    margin-right: auto;
`;

export const AuthSignInInputInvalid = styled.p<authBarProps>`
    font-size: ${TextTheme.sans_300.fontSize};
    font-family: ${TextTheme.sans_300.fontFamily};
    line-height: ${TextTheme.sans_300.lineHeight};
    color: ${ColorTheme.Red1.color};
    margin: 0;
    display: ${(props) => (props.invalid ? "block" : "none")};
`;

export const AuthSignUpProcessingTitle = styled.p`
    margin-top: 32px;
    font-size: ${TextTheme.sans_600_bold.fontSize};
    line-height: ${TextTheme.sans_600_bold.lineHeight};
    font-weight: ${TextTheme.sans_600_bold.fontWeight};
    margin-bottom: 24px;
`;

export const AuthSignUpProcessingSubtitle = styled.p`
    margin: 0;
    font-size: ${TextTheme.sans_300.fontSize};
    line-height: ${TextTheme.sans_300.lineHeight};
    max-width: 270px;
    font-family: ${TextTheme.sans_300.fontFamily};
`;

export const ReactCodeInputWrapper = styled.div<authBarProps>`
    margin-top: 48px;
    margin-left: auto;
    margin-right: auto;
    & .verification-container {
        ${(props) => (props.mfaInvalid ? `border: 1px solid ${ColorTheme.Red1.color};` : null)}
    }
`;

export const AuthSignUpCompleteUploadPlaceButton = styled.button`
    width: 100%;
    height: 48px;
    border-radius: ${BorderRadiusTheme.radius_8.borderRadius};
    margin: 0 auto;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${ColorTheme.Grey1.color};
    font-size: ${ButtonTheme.sans_button_100.fontSize};
    font-family: ${ButtonTheme.sans_button_100.fontFamily};
    line-height: ${ButtonTheme.sans_button_100.lineHeight};
    text-decoration: none;
    background: none;
    cursor: pointer;

    @media (min-width: 768px) {
        font-size: ${ButtonTheme.sans_button_200.fontSize};
        line-height: ${ButtonTheme.sans_button_200.lineHeight};
        margin-top: auto;
        margin-bottom: 20px;
    }
`;

export const AuthSignUpCompleteExploreButton = styled.button`
    width: 100%;
    height: 48px;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    margin: 0 auto;
    margin-top: auto;
    display: flex;
    align-items: center;
    background: ${ColorTheme.Black.color};
    justify-content: center;
    border: none;
    font-size: ${ButtonTheme.sans_button_200.fontSize};
    font-family: ${ButtonTheme.sans_button_200.fontFamily};
    line-height: ${ButtonTheme.sans_button_200.lineHeight};
    color: ${ColorTheme.White.color};
    text-decoration: none;
    cursor: pointer;
`;

export const DOBDatepickerWrapper = styled.div`
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 100%;
    .mbsc-textfield-wrapper {
        display: none;
    }
`;

export const GetSupportButton = styled.a`
    font-size: ${TextTheme.sans_400.fontSize};
    font-family: ${TextTheme.sans_400.fontFamily};
    line-height: ${TextTheme.sans_400.lineHeight};
    margin: 0;
    text-decoration: underline;
`;

export const AuthLoginProcessingTitle = styled.p`
    font-size: ${TextTheme.sans_800_semi.fontSize};
    line-height: ${TextTheme.sans_800_semi.lineHeight};
    font-family: ${TextTheme.sans_800_semi.fontFamily};
    margin-top: 32px;
    margin-bottom: 24px;
`;

export const AuthLoginProcessingSubtitle = styled.p`
    margin: 0;
    font-size: ${TextTheme.sans_300.fontSize};
    max-width: 270px;
    font-family: ${TextTheme.sans_300.fontFamily};
`;

export const AuthWelcomeImage = styled.img`
    width: 100%;
    height: 240px;
    object-fit: cover;
    border-radius: 16px;
`;

export const BackBtn = styled.button`
    position: absolute;
    top: 24px;
    left: 24px;
    width: 40px;
    height: 40px;
    border-radius: ${BorderRadiusTheme.radius_100.borderRadius};
    background: none;
    border: none;
    cursor: pointer;
    z-index: 103;

    @media (min-width: 768px) {
        position: fixed;
        top: 24px;
        left: 24px;
    }
`;

const blink = keyframes`
  50% {
    border-color: transparent;
  }
`;

export const TypingText = styled.p`
    font-size: ${TextTheme.sans_800_semi.fontSize};
    line-height: ${TextTheme.sans_800_semi.lineHeight};
    font-family: ${TextTheme.sans_800_semi.fontFamily};
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
`;